import { Raw, Product, Offer } from 'src/types';

export const isRaw = (
  variableToCheck: Product | Raw | Offer
): variableToCheck is Raw | Offer => {
  return (
    variableToCheck.__typename === 'Raw' ||
    variableToCheck.__typename === 'Offer'
  );
};
